import LoadingSpinner from 'component/LoadingSpinner';
import MultiSelectDropdown from 'component/MultiSelectDropdown';
import TabNavigation from 'component/TabNavigator';
import { Value } from 'domain/model/Value';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ProjectService from 'service/ProjectService';

interface ProjectJobDetailModalProps {
  item: any;
  onClose: (decisionSuccess: boolean) => void;
}

const ProjectJobDetailModal: React.FC<ProjectJobDetailModalProps> = ({ item, onClose }) => {
  const { profile } = useSelector((state: any) => state.auth);

  const projectService = ProjectService();

  const [isLoadingDetail, setIsLoadingDetail] = useState(false);
  const [isLoadingDecision, setIsLoadingDecision] = useState(false);
  const [isLoadingUpdateValue, setIsLoadingUpdateValue] = useState(false);

  const [tabMode, setTabMode] = useState<string>('information');

  const [installerList, setInstallerList] = useState<Value[]>([]);
  const [installerId, setInstallerId] = useState('');

  const fetchDetail = async () => {
    const token = profile?.data.token;
    if (!token) {
      window.alert('Token tidak ditemukan. Silakan login kembali.');
      return;
    }

    setIsLoadingDetail(true);
    try {
    } catch (err: any) {
      console.error(err);
      const errorMessage = err.response?.data?.message || err.message || 'Terjadi kesalahan saat mengambil detail';
      window.alert(`Error: ${errorMessage}`);
    } finally {
      setIsLoadingDetail(false);
    }
  };

  const fetchConfig = async () => {
    const token = profile?.data.token;
    if (!token) {
      window.alert('Token tidak ditemukan. Silakan login kembali.');
      return;
    }
    try {
      const res = await projectService.projectTaskConfig(token, item.projectId);
      setInstallerList(res.data?.installerList || []);
    } catch (err: any) {
      console.error(err);
      const errorMessage = err.response?.data?.message || err.message || 'Terjadi kesalahan saat mengambil konfigurasi';
      window.alert(`Error: ${errorMessage}`);
    } finally {
    }
  };

  const openGoogleMaps = async (lat: number, lng: number) => {
    const url = `https://www.google.com/maps?q=${lat},${lng}`;
    window.open(url, "_blank");
  }

  useEffect(() => {
    fetchDetail();
    fetchConfig();
  }, []);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && !isLoadingDecision && !isLoadingUpdateValue) onClose(false);
    };
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('keydown', handleEsc);
    };
  }, [onClose, isLoadingDecision, isLoadingUpdateValue]);

  return (
    <>
      <div
        className="modal modal-lg show d-block"
        tabIndex={-1}
        role="dialog"
        style={{
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          position: 'fixed',
          inset: 0,
          zIndex: 1050,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        onClick={() => {
          if (!isLoadingDecision && !isLoadingUpdateValue) onClose(false);
        }}
      >
        <div className="modal-dialog modal-lg" role="document" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content" style={{ maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
            <div className="modal-body" style={{ overflowY: 'auto' }}>
              {
                isLoadingDetail ? <LoadingSpinner /> : (
                  <div>
                    <h5 className="mb-1">{item.name}</h5>
                    <p className="text-muted" style={{ fontSize: '0.875rem' }}>
                      Description : {item.description}<br />
                      Project Name : {item.projectName}<br />
                    </p>
                    <div className="mb-3">
                      <i className="fa fa-map-marker-alt me-2"></i> <a href="#" onClick={() => item.latitude != null && item.longitude != null ? openGoogleMaps(item.latitude, item.longitude) : null}>{item.latitude}, {item.longitude}</a>
                    </div>
                    <hr />
                    <div>

                      <div className="d-flex mb-3">
                        <TabNavigation
                          activeTab={tabMode}
                          onTabChange={(tab) => {
                            setTabMode(tab);
                          }}
                          tabs={[
                            { key: "information", label: "Information" },
                          ]}
                        />
                      </div>
                      {tabMode === "information" &&
                        <>
                          <div className="mb-3" />
                          <div className="row">
                            <div className="col-sm-12">
                              <div>
                                {/* <h5 className="mb-4">Basic Information</h5> */}
                                <div className="mb-3">
                                  <label htmlFor="name" className="form-label fw-semibold">Job ID</label>
                                  <input
                                    type="text"
                                    id="name"
                                    className="form-control form-control-compact"
                                    value={item.id}
                                    placeholder="Job ID"
                                    disabled
                                  />
                                </div>
                                <div className="mb-3">
                                  <label htmlFor="description" className="form-label fw-semibold">Description</label>
                                  <input
                                    type="text"
                                    id="description"
                                    className="form-control form-control-compact"
                                    value={item.description}
                                    placeholder="Description"
                                    disabled
                                  />
                                </div>
                                <div className="mb-3">
                                  <label htmlFor="placeName" className="form-label fw-semibold">Place Name</label>
                                  <input
                                    type="text"
                                    id="placeName"
                                    className="form-control form-control-compact"
                                    value={item.placeName}
                                    placeholder="Place Name"
                                    disabled
                                  />
                                </div>
                                <div className="mb-3">
                                  <label htmlFor="latitude" className="form-label fw-semibold">Latitude</label>
                                  <input
                                    type="text"
                                    id="latitude"
                                    className="form-control form-control-compact"
                                    value={item.latitude}
                                    placeholder="Latitude"
                                    disabled
                                  />
                                </div>
                                <div className="mb-3">
                                  <label htmlFor="longitude" className="form-label fw-semibold">Longitude</label>
                                  <input
                                    type="text"
                                    id="longitude"
                                    className="form-control form-control-compact"
                                    value={item.longitude}
                                    placeholder="Longitude"
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      }
                    </div>
                  </div>
                )
              }
            </div>

            <div className="modal-footer justify-content-between">
              <div className="d-flex gap-2">
              </div>
              <div className="d-flex gap-2">
                {/* {
                  status?.key === 3 && !isLoadingDecision && !isLoadingDetail && !isLoadingUpdateValue &&
                  <>
                    <button className="btn btn-danger" onClick={() => setShowRejectModal(true)}>
                      <i className="fa fa-times me-1"></i> Reject
                    </button>
                    <button className="btn btn-primary" onClick={() => handleDecision("approve", "")}>
                      <i className="fa fa-check me-1"></i> Approve
                    </button>
                  </>
                }
                {status?.key !== 3 && !isLoadingDecision && !isLoadingDetail && !isLoadingUpdateValue && (
                  <button
                    className="btn btn-warning"
                    onClick={handleBackToQc}
                  >
                    <i className="fa fa-undo me-1"></i> Back to QC
                  </button>
                )}
                {
                  isLoadingDecision &&
                  <div className="d-flex align-items-center">
                    <LoadingSpinner />
                    <div style={{ marginRight: 8 }} />
                    {decision == "approve" && "Approving.."}
                    {decision == "reject" && "Rejecting.."}
                    {decision == "back_to_qc" && "Sending back to QC.."}
                  </div>
                } */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectJobDetailModal;
